import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { mergeMap, withLatestFrom } from 'rxjs/operators';
import * as release from '@webapp/sdk/release';
import { Action } from 'redux';
import {
  ListReleasesSummaryError,
  ListReleasesSummary,
  ListReleasesSummarySuccess,
} from '../action-creators';
import { LIST_RELEASES_SUMMARY } from '../actions';
import AppState from '../../state';

export const listReleasesSummaryEpic = (
  action$: Observable<Action>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Action, ListReleasesSummary>(LIST_RELEASES_SUMMARY),
    withLatestFrom(state$),
    mergeMap(async ([_, state]) => {
      if (!!state.artist.active) {
        try {
          const summary = await release.summary(
            state.artist.active?.id as string
          );

          return new ListReleasesSummarySuccess(summary);
        } catch (err) {
          new ListReleasesSummaryError((err as Error).message);
        }
      }
      return new ListReleasesSummaryError('NO_ARTIST');
    })
  );
